import React from "react";
import { CardDeal, Footer, SEO } from "../components";
import styles from "../style";

const contactStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntity: {
    '@type': 'Organization',
    name: 'Software India',
    url: 'https://www.softwareindia.com',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      url: 'https://www.softwareindia.com/contact',
      availableLanguage: 'English',
    },
  },
};

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Us | Software India | Get in Touch for Software Development Services"
        description="Contact Software India for all your software development needs. Get expert consultation for web development, mobile apps, UI/UX design, video editing, and branding services. Reach out to our team today."
        keywords="contact software development company, software India contact, web development consultation, IT services contact, software company India, get quote software development, software development inquiry"
        url="https://www.softwareindia.com/contact"
        canonical="https://www.softwareindia.com/contact"
        structuredData={contactStructuredData}
      />
    <div className={`${styles.paddingX} ${styles.flexCenter}`}>
      <div>
        <CardDeal />
        <Footer />
      </div>
    </div>
    </>
  );
}
